import * as React from "react";
import { SVGProps, memo } from "react";

const SvgReceivingMedication = (props: SVGProps<SVGSVGElement>) => (
  <svg width={64} height={64} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M32.24 14.907V39.92a1.834 1.834 0 0 1-1.826 1.832h-15.5c-.239 0-.479-.047-.7-.14a1.821 1.821 0 0 1-1.13-1.691V14.91c0-.485.196-.95.539-1.29a1.828 1.828 0 0 1 1.292-.536h5.925c.484 0 .949.193 1.29.536.343.343.535.805.535 1.29 0-.485.195-.95.538-1.29a1.828 1.828 0 0 1 1.293-.536h5.925a1.832 1.832 0 0 1 1.82 1.82h-.002Z"
      fill="#ECF9F2"
    />

    <path
      d="M30.414 42.34H14.915c-.32 0-.632-.064-.925-.186a2.39 2.39 0 0 1-.785-.526 2.395 2.395 0 0 1-.705-1.708V14.913c0-.646.254-1.25.71-1.706a2.398 2.398 0 0 1 1.705-.707h5.925a2.397 2.397 0 0 1 1.826.836c.04-.044.08-.089.122-.129a2.399 2.399 0 0 1 1.708-.707h5.925a2.392 2.392 0 0 1 1.699.707 2.4 2.4 0 0 1 .707 1.696V39.92c0 .317-.061.63-.18.923a2.438 2.438 0 0 1-1.306 1.311 2.402 2.402 0 0 1-.927.186ZM14.915 13.675c-.331 0-.641.129-.876.364a1.23 1.23 0 0 0-.364.876V39.92c0 .164.03.324.094.477a1.247 1.247 0 0 0 1.146.77h15.5a1.237 1.237 0 0 0 1.144-.768c.063-.15.093-.312.093-.474V14.908c0-.329-.131-.639-.364-.871a1.239 1.239 0 0 0-.872-.365h-5.922a1.25 1.25 0 0 0-.877.364 1.23 1.23 0 0 0-.364.877.588.588 0 0 1-1.175 0c0-.331-.129-.642-.364-.877a1.23 1.23 0 0 0-.876-.364h-5.923v.003Z"
      fill="#194D33"
    />

    <path d="M26.17 21.229a1.72 1.72 0 1 0 0-3.44 1.72 1.72 0 0 0 0 3.44Z" fill="#8CD9B2" />

    <path
      d="M26.17 21.7a2.192 2.192 0 0 1-2.19-2.19c0-1.208.982-2.19 2.19-2.19 1.207 0 2.19.982 2.19 2.19 0 1.207-.983 2.19-2.19 2.19Zm0-3.44c-.689 0-1.25.562-1.25 1.25s.561 1.25 1.25 1.25c.688 0 1.25-.562 1.25-1.25s-.562-1.25-1.25-1.25Z"
      fill="#194D33"
    />

    <path d="M26.17 29.252a1.72 1.72 0 1 0 0-3.44 1.72 1.72 0 0 0 0 3.44Z" fill="#8CD9B2" />

    <path
      d="M26.17 29.723a2.192 2.192 0 0 1-2.19-2.19c0-1.207.982-2.19 2.19-2.19 1.207 0 2.19.983 2.19 2.19 0 1.208-.983 2.19-2.19 2.19Zm0-3.44c-.689 0-1.25.562-1.25 1.25 0 .689.561 1.25 1.25 1.25.688 0 1.25-.561 1.25-1.25 0-.688-.562-1.25-1.25-1.25Z"
      fill="#194D33"
    />

    <path d="M26.17 37.268a1.72 1.72 0 1 0 0-3.44 1.72 1.72 0 0 0 0 3.44Z" fill="#8CD9B2" />

    <path
      d="M26.17 37.739a2.192 2.192 0 0 1-2.19-2.19c0-1.208.982-2.19 2.19-2.19 1.207 0 2.19.982 2.19 2.19s-.983 2.19-2.19 2.19Zm0-3.44c-.689 0-1.25.562-1.25 1.25s.561 1.25 1.25 1.25c.688 0 1.25-.562 1.25-1.25s-.562-1.25-1.25-1.25Z"
      fill="#194D33"
    />

    <path d="M19.291 21.229a1.72 1.72 0 1 0 0-3.44 1.72 1.72 0 0 0 0 3.44Z" fill="#8CD9B2" />

    <path
      d="M19.29 21.7a2.192 2.192 0 0 1-2.189-2.19c0-1.208.982-2.19 2.19-2.19 1.207 0 2.19.982 2.19 2.19 0 1.207-.983 2.19-2.19 2.19Zm0-3.44c-.688 0-1.25.562-1.25 1.25s.562 1.25 1.25 1.25c.69 0 1.25-.562 1.25-1.25s-.56-1.25-1.25-1.25Z"
      fill="#194D33"
    />

    <path d="M19.291 29.252a1.72 1.72 0 1 0 0-3.44 1.72 1.72 0 0 0 0 3.44Z" fill="#8CD9B2" />

    <path
      d="M19.29 29.723a2.192 2.192 0 0 1-2.189-2.19c0-1.207.982-2.19 2.19-2.19 1.207 0 2.19.983 2.19 2.19 0 1.208-.983 2.19-2.19 2.19Zm0-3.44c-.688 0-1.25.562-1.25 1.25 0 .689.562 1.25 1.25 1.25.69 0 1.25-.561 1.25-1.25 0-.688-.56-1.25-1.25-1.25Z"
      fill="#194D33"
    />

    <path d="M19.291 37.268a1.72 1.72 0 1 0 0-3.44 1.72 1.72 0 0 0 0 3.44Z" fill="#8CD9B2" />

    <path
      d="M19.29 37.739a2.192 2.192 0 0 1-2.189-2.19c0-1.208.982-2.19 2.19-2.19 1.207 0 2.19.982 2.19 2.19s-.983 2.19-2.19 2.19Zm0-3.44c-.688 0-1.25.562-1.25 1.25s.562 1.25 1.25 1.25c.69 0 1.25-.562 1.25-1.25s-.56-1.25-1.25-1.25Z"
      fill="#194D33"
    />

    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M50.677 50.91c.52 0 .94-.421.94-.94V24.595a.94.94 0 0 0-.94-.94H25.304a.94.94 0 0 0-.94.94v25.373c0 .52.42.94.94.94h25.373Z"
      fill="#fff"
    />

    <path
      d="M50.677 51.498H25.304a1.53 1.53 0 0 1-1.528-1.527V24.597a1.53 1.53 0 0 1 1.527-1.527h25.374a1.53 1.53 0 0 1 1.527 1.527v25.374a1.53 1.53 0 0 1-1.527 1.527ZM25.304 24.245a.352.352 0 0 0-.353.352v25.374c0 .195.157.352.352.352h25.374a.352.352 0 0 0 .352-.352V24.597a.352.352 0 0 0-.352-.352H25.304Z"
      fill="#194D33"
    />

    <path
      d="M47.154 47.74H28.829a.588.588 0 0 1-.588-.587V33.056c0-.324.263-.587.588-.587h18.325c.324 0 .587.263.587.587v14.097a.588.588 0 0 1-.587.587Zm-17.738-1.175h17.15V33.643h-17.15v12.922ZM47.154 27.422H28.829v2.82h18.325v-2.82Z"
      fill="#194D33"
    />

    <path
      d="M47.154 30.83H28.829a.588.588 0 0 1-.588-.587v-2.82c0-.324.263-.587.588-.587h18.325c.324 0 .587.263.587.587v2.82a.588.588 0 0 1-.587.587Zm-17.738-1.175h17.15v-1.644h-17.15v1.644ZM46.566 37.753H29.65a.588.588 0 0 1 0-1.175h16.916a.588.588 0 0 1 0 1.175Z"
      fill="#194D33"
    />
  </svg>
);

const Memo = memo(SvgReceivingMedication);

export default Memo;
